import React, { useEffect, useState } from 'react';
import { serverUrl } from '../../../Constant/Static/config';
import axios from 'axios';

function PaymentRefresh() {
    const [paymentLoading, setPaymentLoading] = useState(false)
    const [singlePaymentLoading, setSinglePaymentLoading] = useState(false)
    const [fromValue, setFromValue] = useState('');
    const [toValue, setToValue] = useState('');
    const [result, setResult] = useState(null);
    const [error, setError] = useState('');
    const [csrfToken, setCsrfToken] = useState('');

    const [applicationNo, setApplicationNo] = useState('');
    const [applicationResult, setApplicationResult] = useState(null);
    const [applicationError, setApplicationError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Check if input values are integers
        if (isNaN(fromValue) || isNaN(toValue) || fromValue === '' || toValue === '') {
            setError('Please enter valid integers for both values.');
            return;
        }
        setError('');
        const data = {
            from: parseInt(fromValue),
            to: parseInt(toValue),
        };
        setPaymentLoading(true)

        try {
            // Send the request to the API using Axios
            const response = await axios.post(`${serverUrl}/api/admin/payment-status`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'CSRF-Token': csrfToken, // Include CSRF token in the headers
                },
                withCredentials: true,
            });
            setResult(response.data);
        } catch (err) {
            setError('Failed to fetch data from API');
        } finally {
            setPaymentLoading(false);
        }
    };

    const handleApplicationSubmit = async (e) => {
        e.preventDefault();
        if (!applicationNo) {
            setApplicationError('Please enter a valid application number.');
            return;
        }
        setApplicationError('');
        const data = {
            appNo: applicationNo,
        };
        
        setSinglePaymentLoading(true)
        try {
            const response = await axios.post(`${serverUrl}/api/admin/payment-single-status`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'CSRF-Token': csrfToken, // Include CSRF token in the headers
                },
                withCredentials: true,
            });
            setApplicationResult(response.data);
        } catch (err) {
            setApplicationError('Failed to fetch data from API');
        } finally {
            setSinglePaymentLoading(false);
        }
    };

    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true  // Ensure cookies are sent
                });
                setCsrfToken(response.data.csrfToken);  // Set CSRF token
            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            }
        };

        fetchCsrfToken();
    }, []);


    return (
        <div className="transfer-container">
            <h1 className="title">Payment Refresh By Range</h1>
            <form className="form" onSubmit={handleSubmit}>
                <div>
                    <div className="input-group">
                        <label htmlFor="from">From:</label>
                        <input
                            type="number"
                            id="from"
                            value={fromValue}
                            min="1" max="30000"
                            onChange={(e) => setFromValue(e.target.value)}
                            placeholder="Enter from value (S.No)"
                            className="input-field"
                        />
                    </div>

                    <div className="input-group">
                        <label htmlFor="to">To:</label>
                        <input
                            type="number"
                            id="to"
                            value={toValue}
                            min="1" max="30000"
                            onChange={(e) => setToValue(e.target.value)}
                            placeholder="Enter to value (S.No)"
                            className="input-field"
                        />
                    </div>
                </div>

                {!paymentLoading ? <button type="submit" className="submit-btn">Submit</button> : <p style={{textAlign:'center',fontWeight:'bold'}}>Loading..!</p>}
            </form>

            {/* Show error message if any */}
            {error && <p className="error-message">{error}</p>}

            {/* Display the result from API */}
            {result && (
                <div className="result">
                    <h2>Result:</h2>
                    <pre>{JSON.stringify(result, null, 2)}</pre>
                </div>
            )}

            <h3 className="title">Payment Refresh By Application No.</h3>
            <form className="form" onSubmit={handleApplicationSubmit}>
                <div className="input-group">
                    <label htmlFor="applicationNo">Application No:</label>
                    <input
                        type="text"
                        id="applicationNo"
                        value={applicationNo}
                        onChange={(e) => setApplicationNo(e.target.value)}
                        placeholder="Enter application number"
                        className="input-field"
                    />
                </div>

                {!singlePaymentLoading ? <button type="submit" className="submit-btn">Submit</button> : <p style={{textAlign:'center',fontWeight:'bold'}}>Loading..!</p>}
            </form>

            {/* Show error message if any */}
            {applicationError && <p className="error-message">{applicationError}</p>}

            {/* Display the result from application API */}
            {applicationResult && (
                <div className="result">
                    <h2>Application Result:</h2>
                    <pre>{JSON.stringify(applicationResult, null, 2)}</pre>
                </div>
            )}
        </div>
    )
}

export default PaymentRefresh;